export default __webpack_public_path__ + "a0ba03633ed2931bda140066cee4b87f.svg";